import { IRecording } from '../../recording/RecordingState';
import { WaveformLinesIcon } from '../../theme/Icons';
import { AITranscription } from '../generic-notes/AITranscription';
import { ViewNoteSection } from './ViewNoteSection';
import dayjs from 'dayjs';

export const Transcription: React.FC<{note: any}> = ({ note }) => {
    const recording = note.otherAttributes?.recording as IRecording;

    const formatRecordingDate = (date: string) => {
        const dayjsDate = dayjs(date);
        const format = dayjsDate.isToday() ? 'h:mma' : 'MMMM D, YYYY [at] h:mma';
        return dayjsDate.format(format);
    };

    return recording?.transcription && (
        <ViewNoteSection title="Transcription" Icon={WaveformLinesIcon} showAIIcon>
            {recording.created && (
                <div style={{
                    fontSize: '14px',
                    color: 'var(--ion-color-step-600, #666666)',
                    marginBottom: '12px'
                }}>
                    Recorded {formatRecordingDate(recording.created)}
                </div>
            )}
            <AITranscription recording={recording} />
        </ViewNoteSection>
    );

};
